// extracted by mini-css-extract-plugin
export var button = "_5a-7";
export var buttonRow = "_5a-6";
export var fadeIn = "_5a-1";
export var gradient = "_5a-0";
export var panel = "_5a-2";
export var panelIn = "_5a-3";
export var subtitle = "_5a-5";
export var title = "_5a-4";